// Components
import { RefreshButton } from '@/components/pages/conversations/SocialInbox/components/SocialInboxMessageList/SocialInboxHeader/SocialInboxActions/RefreshButton';

export function ConversationActions() {
    return (
        <div className="flex space-x-3">
            {/* TODO: Group Conversation V2 */}
            {/* <Icon icon="trash" className="text-12 text-icoBlack dark:text-white" />
                    <Icon icon="mail-open" className="text-12 text-icoBlack dark:text-white" /> */}
            <RefreshButton />
            {/* TODO: Group Conversation V2 */}
            {/* <Icon icon="mail" className="text-12 text-icoBlack dark:text-white" /> */}
        </div>
    );
}
